<template>
  <div>
    <div class="fw-500 mb-1" v-if="show">{{ t('language.translate') }}</div>
    <div class="mb-2 of-hidden flex items-center justify-between" v-if="show">
      <!-- <div>{{ TargetLanguage }}=={{ Type }}</div> -->
      <a-tooltip :title="t('language.targetLanguage')">
        <a-select size="middle" :options="targetLanguageList" v-model:value="TargetLanguage" style="width: 49%">
        </a-select>
      </a-tooltip>
      <a-tooltip :title="t('language.translateEngine')">
        <a-select
          size="middle"
          :options="enginList"
          v-model:value="Type"
          style="width: 49%"
          @change="setTranslateEngine"
        >
        </a-select>
      </a-tooltip>
      <!-- {{ values.source }}== -->
    </div>
    <div class="mb-2" v-if="show">
      <a-button
        class="btn-translate"
        type="default"
        size="middle"
        :disabled="!values.source"
        :loading="translating"
        @click="doTranslate"
      >
        {{ t('language.translate') }}
      </a-button>
    </div>
    <div>
      <div class="fw-500 mb-1">
        {{ t('propsEditor.translatedText') }}
        <a-tooltip :title="t('common.copy')" placement="top">
          <copy-outlined @click="copyText(field.value)" style="font-size: 13px" />
        </a-tooltip>
      </div>
      <a-textarea
        :disabled="disabled"
        :placeholder="config.placeholder || `${config.label}`"
        :value="field.value"
        :maxlength="config.maxlength"
        :show-count="!!config.maxlength"
        allow-clear
        @change="handleChange"
        @blur="onBlur"
      />
    </div>
  </div>
</template>
<script>
import { props } from './helper';
import { computed, defineComponent, nextTick, ref } from 'vue';
import { translateText } from '@/apis/app';
import { useStore } from 'vuex';
import { message, Modal } from 'ant-design-vue';
import { sendLog } from '@/utils/sentry';
import { useRoute } from 'vue-router';
import i18n from '@/locales/i18n';
import { setTranslateEngine, getTranslateEngine } from '@/utils/ls';
import { copyText } from '@/utils';
import { CopyOutlined } from '@ant-design/icons-vue';

const { t } = i18n.global;
export default defineComponent({
  props,
  emits: ['component-event', 'input'],
  components: { CopyOutlined },
  setup(props, { emit }) {
    const store = useStore();
    const appState = computed(() => store.state.app);
    const route = useRoute();
    const isDesktop = !!window.$desktopEnv;

    const onBlur = () => {
      nextTick(() => {
        emit('component-event', {
          name: 'input-blur',
          item: props.field,
          config: props.config,
        });
      });
    };
    const TargetLanguage = ref(appState.value.targetLanguage);
    const Type = ref(getTranslateEngine());
    const translating = ref(false);

    const { TextTransSign, CommitTime, TextTransKey } = route.query;
    const isInERP = TextTransSign && CommitTime && TextTransKey;

    const doTranslate = async () => {
      translating.value = true;
      try {
        const { Text } = await translateText({
          SourceLanguage: appState.value.sourceLanguage,
          TargetLanguage: TargetLanguage.value,
          Text: props.values.source,
          Type: Type.value,
          isInERP,
          TextTransSign,
          CommitTime,
          TextTransKey,
        });
        props.handleChange(Text);
        message.success(t('translateSuccess'));
        console.log(111);
        sendLog('text_translate:success');
      } catch (err) {
        console.log(222, err);
        sendLog('text_translate:error');
        Modal.error({
          title: err,
          okText: isInERP || isDesktop ? t('understood') : t('checkCredit'),
          closable: true,
          content: isInERP || isDesktop ? '' : t('textTranslateChargeTip'),
          onOk() {
            if (!isInERP && !isDesktop) {
              sendLog('text_translate:go2charge');
              window.open('/console/charge?type=2');
            }
          },
        });
      }
      translating.value = false;
    };

    const SourceLanguage = ref(appState.value.sourceLanguage);
    const onSourceLangChang = e => {
      SourceLanguage.value = e;
      props.setFieldValue('SourceLanguage', e);
    };

    const show = computed(() => {
      const { UserKey, TextTransKey } = appState.value.userInfo;
      return import.meta.env.DEV || (props.config.type === 'target' && (isInERP || (UserKey && TextTransKey)));
    });

    const targetLanguageList = computed(() => [
      { value: 'KOR', label: t('language.KOR') },
      { value: 'JPN', label: t('language.JPN') },
      { value: 'RUS', label: t('language.RUS') },
      { value: 'ENG', label: t('language.ENG') },
      { value: 'FRA', label: t('language.FRA') },
      { value: 'DEU', label: t('language.DEU') },
      { value: 'HUN', label: t('language.HUN') },
      { value: 'ITA', label: t('language.ITA') },
      { value: 'PLK', label: t('language.PLK') },
      { value: 'CSY', label: t('language.CSY') },
      { value: 'NLD', label: t('language.NLD') },
      { value: 'PTB', label: t('language.PTB') },
      { value: 'ROM', label: t('language.ROM') },
      { value: 'ESP', label: t('language.ESP') },
      { value: 'TRK', label: t('language.TRK') },
      { value: 'VIN', label: t('language.VIN') },
      { value: 'CHS', label: t('language.CHS') },
      { value: 'CHT', label: t('language.CHT') },
      { value: 'AR', label: t('language.AR') },
      { value: 'ID', label: t('language.ID') },
      { value: 'TH', label: t('language.TH') },
      { value: 'MS', label: t('language.MS') },
      { value: 'TL', label: t('language.TL') },
      { value: 'JW', label: t('language.JW') },
      { value: 'MY', label: t('language.MY') },
      { value: 'BG', label: t('language.BG') },
    ]);

    const enginList = computed(() => [
      { value: 0, label: t('language.ali') },
      { value: 1, label: t('language.google') },
      { value: 2, label: t('language.papago') },
      { value: 3, label: t('language.baidu') },
      { value: 4, label: t('language.deepl') },
      { value: 5, label: 'ChatGPT' },
    ]);

    return {
      t,
      show,
      isInERP,
      appState,
      onBlur,
      targetLanguageList,
      enginList,
      TargetLanguage,
      Type,
      translating,
      doTranslate,
      SourceLanguage,
      onSourceLangChang,
      setTranslateEngine,
      copyText,
    };
  },
});
</script>
<style lang="less" scoped>
.btn-translate {
  width: 100%;
  transition: none;
}
</style>
